import React from 'react';
import { Elements } from 'prismic-richtext';
import { Typography } from '@mui/material';

import { colors } from '../../../styles/_colors';
import SunnysideLink from '../../../components_sunnyside/link';
import SunnysideBulletPoint from '../../../components_sunnyside/bullet_point';

// -- Function to add unique key to props
const propsWithUniqueKey = function(props, key) {
    return Object.assign(props || {}, { key });
};

const cookiePolicySerializer = function(type, element, content, children, key) {
    const props = {};

    switch(type) {
    case Elements.heading1:
        return (
            <Typography variant='h1'
                key={propsWithUniqueKey(props, key)}>
                {children}
            </Typography>
        );
    case Elements.heading2:
        return (
            <Typography variant='terms_article_header' key={propsWithUniqueKey(props, key)}>
                {children}
            </Typography>
        );
    case Elements.heading3:
        return (
            <Typography variant='terms_article_small_header' key={propsWithUniqueKey(props, key)}>
                {children}
            </Typography>
        );
    case Elements.paragraph:
        return (
            <Typography variant='terms_body' key={propsWithUniqueKey(props, key)}>
                {children}
            </Typography>
        );
    case Elements.list:
        return (
            <ul 
                key={propsWithUniqueKey(props, key)} 
                style={{ 
                    marginBottom: '2rem' 
                }}>
                {children}
            </ul>
        );
    case Elements.listItem: 
        return (
            <SunnysideBulletPoint key={propsWithUniqueKey(props, key)}>
                {children}
            </SunnysideBulletPoint>
        );
    case Elements.oList:
        return (
            <ol 
                key={propsWithUniqueKey(props, key)} 
                style={{ 
                    marginBottom: '2rem' 
                }}>
                {children}
            </ol>
        );
    case Elements.oListItem: 
        return (
            <SunnysideBulletPoint key={propsWithUniqueKey(props, key)}>
                {children}
            </SunnysideBulletPoint>
        );
    case Elements.hyperlink:
        return (
            <SunnysideLink href={element.data.url}
                color={colors.sky}
                fontVariant='terms_body'
                key={propsWithUniqueKey(props, key)}>
                {children}
            </SunnysideLink>
        );

    // Return null to stick with the default behavior
    default:
        return null;
    }
};

export default cookiePolicySerializer;